const o = {
  size: "medium",
  iconPosition: "right",
  htmlType: "button"
}, e = [
  "size",
  "ghost",
  "disabled",
  "icon",
  "children",
  "className",
  "style",
  "onClick",
  "iconPosition",
  "loading",
  "color",
  "borderColor",
  "backgroundColor",
  "activeColor",
  "activeBorderColor",
  "activeBackgroundColor",
  "disabledColor",
  "disabledBorderColor",
  "disabledBackgroundColor"
], r = [
  "className"
];
export {
  r as baseButtonAnimateProps,
  e as baseButtonProps,
  o as defaultReoButtonProps
};
//# sourceMappingURL=const.mjs.map
